import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  cargarProcesoActivo,
  listaFuncionariosNoPrecalificados,
} from "../../utils/Datos";
import { PlaceholderTabla } from "../Otros/Placeholder";
import { Tabla } from "../Otros/Tabla";
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import TablaDatos from "../Otros/TablaDatos";

export const ListaNoPrecalificados = ({ idProcess, precalificador }) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [listaFuncionarios, setListaFuncionarios] = useState(null);
  const [etapaActiva, setEtapaActiva] = useState(null);
  const user = useSelector(selectUser);
  console.log(user);
  let navigate = useNavigate();
  useEffect(() => {
    setCargandoDatos(true);
    const payload = {
      id_process: idProcess,
      id_officer: user.user.id_officer,
    };
    listaFuncionariosNoPrecalificados(payload).then((datos) => {
      setListaFuncionarios(datos);
      setCargandoDatos(false);
    });
  }, [idProcess]);

  useEffect(() => {
    cargarProcesoActivo().then((datos) => {
      datos.qualificationStages.forEach((e) => {
        const ahora = Date.now();
        const inicio = Date.parse(e.starDate);
        if (inicio <= ahora) {
          setEtapaActiva(e.id_stages);
        }
      });
    });
  }, []);

  const handleClick = (id_participant, id_preQualifications) => {
    const url = `/verPrecalificacion?id_participant=${id_participant}&id_preQualifications=${id_preQualifications}`;
    navigate(url, {});
  };

  const columnas = [
    {
      label: "Etapa",
      field: "nameStage",
      envoltorio: null,
    },
    {
      label: "RUT",
      field: "rutOfficer",
      envoltorio: ({ children }) => <>{children}</>,
    },
    {
      label: "Nombre",
      field: "nameOfficer",
      envoltorio: null,
    },
    {
      label: "Dirección",
      field: "nameMunicipalDirection",
      envoltorio: null,
    },
    {
      label: "Unidad",
      field: "nameMunicipalUnit",
      envoltorio: null,
    },
    {
      label: "Cargo",
      field: "nameProfile",
      envoltorio: null,
    },
    {
      label: "Escalafón",
      field: "scale_officer",
      envoltorio: null,
    },
    {
      label: "Grado",
      field: "gradeOfficer",
      envoltorio: null,
    },
    {
      label: "Acciones",
      field: "actions",
      title: "Precalificar",
      envoltorio: null,
    },

  ];


  return (
    <>
      {cargandoDatos || listaFuncionarios == null || etapaActiva == null ? (
        <PlaceholderTabla></PlaceholderTabla>
      ) : (
        <TablaDatos 
          columns={columnas} 
          handleActionClick={(e) => {
            handleClick(e.id_participant, e.id_preQualifications);
          }} 
          data={listaFuncionarios.filter(
                  (precalificacion) => precalificacion.id_stages <= etapaActiva
                )} 
        />
        
      )}
    </>
  );
};
